import { Translation } from 'src/types';

const translations: Translation = {
  translation: {
    Buttons: {
      back: 'Geri',
      changePassword: 'Parolayı Değiştir',
      copiedVaultId: 'Kopyalandı!',
      copyVaultID: 'Vault Kimlik Numarasını Kopyala',
      create: 'Oluştur',
      next: 'Sonraki',
      notSure: 'Emin değilim',
      signUp: 'Kaydol',
      submit: 'Gönder',
      updatePassword: 'Şifreyi güncelle',
    },
    Errors: {
      createReportFailed: 'Rapor oluşturma başarısız.',
    },
    ReportStatus: {
      CLOSED: 'Kapalı',
      INVESTIGATING: 'İnceleniyor',
      NEW: 'Gönderildi',
      READ: 'Oku',
    },
    general: {
      navbar: {
        caseSettings: 'Dava ayarları',
        changePassword: 'Şifre değiştir',
        logOut: 'Oturumu kapat',
        notifications: 'Bildirimler',
        notificationsDrawer: {
          appFileScanFailed: 'Bir dosya güvenlik kontrolünü geçemedi',
          appReportMatch: 'GoTogether kaydınız eşleştirildi',
          appReportReassigned: 'Yeni bir dosya yöneticisi atanmıştır.',
          case: 'Dava',
          caseAssigned: 'Sizinle ilgili dava atandı',
          caseImporterJobCompleted: {
            PartialSuccess: 'Hata ile tamamlanan dosya ithalatınız',
            failure: 'Durumunuzun içe aktarımı başarısız oldu',
            success: 'Dosya içe aktarmanız başarıyla tamamlandı.',
          },
          caseLinked: 'Bağlantılı durum',
          caseTeamInvite: 'Vakaya eklendi',
          caseUnlinked: 'Dava bağlantısı kaldırıldı',
          dataSanitisation: 'Rapor detayları güncellendi',
          emptyDescription: 'Daha sonra yeni bildirimler için geri dönün',
          emptyTitle: 'Tüm işlerinizi tamamladınız',
          importId: 'İthalat ID:',
          learnMore: 'Daha fazla öğren',
          markAllAsRead: 'Hepsini okundu olarak işaretle',
          newMessage: 'Yeni mesaj',
          newReport: 'Yeni rapor alındı',
          permissionRemoved: 'Davadan çıkarıldı',
          postSSubmissionFile: 'Delil dosya(sı) eklendi',
          report: 'Rapor',
          reportAssigned: 'Sana atanan rapor',
          reportStatusChange: 'Rapor durumu değişti',
          reporterAnonymised: 'Detaylarınız anonim hale getirildi',
          reporterReportSubmitted: {
            subtitle: 'Raporunuzun bir kopyasını kaydetmenizi öneririz',
            title: 'Rapor sunuldu',
          },
          mitigationPlanReminder: 'Azaltma planı onayı gerekli',
          staleCase: 'İşlem yapılmamış durum',
        },
        privacyStatement: 'Gizlilik beyanı',
        reporter: {
          myReports: 'Benim raporlarım',
        },
        settings: 'Ayarlar',
        technicalSupport: 'Teknik destek',
        title: 'Hesap',
      },
      time: {
        day: 'Gün',
        days: 'Günler',
        hour: 'Saat',
        hours: 'Saatler',
        minute: 'Dakika',
        minutes: 'Dakikalar',
        second: 'İkinci',
        seconds: 'Saniyeler',
      },
    },
    public: {
      ChatContainer: {
        anonymousLabel: 'Anonim',
        autoTranslate: 'Otomatik çeviri varsayılan olarak kapalıdır.',
        backToMessages: 'Mesajlara geri dön',
        caseSettings: 'Durum ayarları.',
        changeInProfile:
          'Bu ayarı değiştirmek isterseniz, profilinizde bunu yapabilirsiniz.',
        deletedByMessage: '{{author}} tarafından silindi',
        deletedMessageLabel: 'Bu mesaj silindi',
        description:
          'Otomatik çeviri açık olduğunda, tüm rapor mesajları\n          tarayıcınızda seçili olan varsayılan dil üzerinden AI kullanılarak\n          otomatik olarak çevrilecektir.',
        descriptionSecondHalf:
          'Tüm mesajların orijinal sürümü her zaman korunur ve sohbet içinde bulunabilir.',
        messagePlaceholder: 'Yazmaya başlayın...',
        messageSettings: 'Mesaj ayarları.',
        originalMessages: 'Orjinal',
        showMoreBanner: 'Otomatik çeviriler hakkında daha fazla bilgi edinin',
        titlev2: 'Tercih ettiğiniz dilde tüm mesajları okuyun.',
        translatedMessageLabel: 'Çevrilmiş Mesaj',
        translatedMessages: 'Çevrildi',
        understood: 'Anlaşıldı',
      },
      Country: {
        description: 'Hangi ülkede çalışıyorsunuz?',
        header: 'Hangi ülkede çalışıyorsunuz?',
        noOptions: 'Ülke bulunamadı',
        other: 'Diğer',
        placeholder: 'Ülke ara...',
      },
      CreatePublicReport: {
        createReport: 'Yeni rapor oluştur',
        helpPage: 'Yardım sayfamıza gidin',
        loginToOpr: 'Raporları Takip Etmek için Giriş Yapın',
        or: 'veya',
        passwordPlaceholder: 'Parola gir',
        phoneNumberLoginFailed:
          'Giriş başarısız, telefon numarası / pin yanlış',
        phoneNumberPlaceholder: 'Telefon Numaranızı Girin',
        phoneNumberTooltip:
          'VaultTalk ile iletişim kurmak için kullandığınız telefon numarasını girin',
        pinPlaceholder: 'Pin Giriniz',
        reportIntroductionParagraph1:
          'Bir olayı bildirirken, deneyiminizi belgelendirmenize yardımcı olmak için size birkaç soru sorulacaktır.',
        reportIntroductionParagraph2:
          'Göndermeden önce, gizliliğinizi korumak için anonim kalma seçeneğine sahipsiniz.',
        reportIntroductionParagraph3:
          'Gönderdikten sonra, raporunuzun ilerleyişi hakkında bilgi almak ve bir dosya yöneticisi ile konuşmak için istediğiniz zaman giriş yapabilirsiniz.',
        reportIssue: 'Sorun bildir',
        usernameLoginFailed: 'Giriş başarısız, kullanıcı adı/şifre yanlış',
        validationError: {
          publicReport: {
            relationshipToCompanyRequired: 'Şirket ile ilişki gereklidir',
            reportedCategoryRequired: 'Raporlanan kategori gereklidir',
          },
        },
        vaultId: 'Vault Kimlik Numarası',
        vaultIdPlaceholder: "E-postanızı veya Vault ID'nizi girin",
        vaultIdTooltip:
          "Anonim raporlar için Vault ID alfanümeriktir. Rapor anonim değilse, Vault ID'niz e-posta adresinizdir.",
        vaultTalk: 'VaultTalk',
        yourPassword: 'Şifreniz',
        yourPhoneNumber: 'Telefon Numaranız',
        yourPin: '6 Haneli Pininiz',
        yourVaultId: 'Vault Kimlik Numaranız',
      },
      CustomHeader: {
        companyLogo: 'Şirket Logosu',
        openReporting: 'Bildirme İşlevini Aç',
        userSettings: 'Kullanıcı Ayarları',
      },
      Date: {
        approximateDescription:
          'Olayın meydana geldiği yaklaşık tarihi hatırlıyor musunuz?',
        approximatePlaceholder: 'Örneğin: 6 ay önce / geçen yıl / geçen Kasım',
        cancel: 'iptal',
        clear: 'temizle',
        description: 'Olayın meydana geldiği tarihi hatırlıyor musunuz?',
        header: 'Hangi gün meydana geldi?',
        ok: 'tamam',
        placeholder: 'Örneğin: 21 Haziran 2020',
      },
      Description: {
        whatHappened: 'Ne oldu?',
        whatHappenedPlaceholder: 'Kendi ifadelerinizi kullanın...',
        whatHappenedText: 'Ne olduğunu kendi ifadeleriniz ile anlatın',
      },
      Details: {
        disclaimer:
          'Bu detaylar raporunuzla birlikte açıklanacaktır. Anonim kalmak isterseniz, kimlik belirleyici bilgiler içermediğinden emin olun.',
        emailPlaceholder: 'E-posta adresiniz (isteğe bağlı)',
        fullNamePlaceholder: 'Ad ve Soyadınız (isteğe bağlı)',
        header: 'Bilgileriniz',
        nonAnonSubtitle:
          'Lütfen adınızı veya bir e-posta adresi sağlayın. Bu rapor hakkında bildirim almak istiyorsanız, aşağıya uygun bir e-posta adresi ekleyin.',
        nonOptionalEmailPlaceholder: 'E-posta',
        nonOptionalFullNamePlaceholder: 'Tam İsim',
        subtitle:
          'Bu rapor hakkında bildirim almak istiyorsanız, aşağıya uygun bir e-posta adresi ekleyin.',
      },
      Emotion: {
        description: 'Bu olay karşısında ne hissettiniz? Etkisi ne oldu?',
        header: 'Etkisi ne oldu?',
        placeholder: 'Yazmaya başlayın...',
      },
      Evidence: {
        addedHeading: 'Eklendi',
        deletedMessage: 'silindi',
        deletedStatus: 'Silindi',
        failedToOpenFileMessage: 'Dosya açılamadı. Lütfen tekrar deneyin.',
        fileStatuses: {
          infectedUpload: 'Güvenlik kontrolü tarafından işaretlendi',
          passedUpload: 'Güvenlik kontrolünden geçti',
          pendingUpload: 'Güvenlik kontrolü devam ediyor',
          readyForDownload: 'İndirmeye hazır',
        },
        mobileErrorMessage:
          'İşaretlenmiş dosyalar: dosya yöneticinize mesaj gönderin',
        nameHeading: 'İsim',
        statusHeading: 'Durum',
        tableTitle: 'Kanıt',
        webErrorMessage:
          'İşaretlenmiş dosyalar: Eğer dosyanız işaretlenmişse, lütfen durum yöneticisine mesaj atın.',
      },
      FileUpload: {
        addFiles: 'Dosya Ekle',
        addMoreFiles: 'Daha fazla dosya ekle',
        confirm: 'Onayla',
        description:
          'Dosyaları kanıt olarak eklemek, dosya içeriği (dosya metaverileri dahil) hakkında düşünmeniz ve anonim kalmak istiyorsanız, diğer bireylerin haklarına ve geçerli yasalara saygı göstermeniz durumunda, dosya yöneticinizin çözüm etkinliğini desteklemeye yardımcı olabilir. Lütfen bunları dikkate alın.',
        dragDrop: 'Dosyaları buraya bırakın veya',
        errorMessage:
          'Dosya(lar) bir ağ hatası nedeniyle başarısız oldu. Yardım için durum yöneticinize mesaj göndermek için aşağıya tıklayın.',
        fileLimit: 'Her dosya boyutu limiti: 100MB',
        fileUploadLimitText: 'Yalnızca 10 dosya yükleyebilirsiniz',
        header: 'Kanıt ekle',
        helpArticle: 'yardım makalesi',
        highlighted: 'Dosyalara göz at',
        information: 'Desteklenen dosya türleri',
        moreInformation:
          'Daha fazla bilgi için lütfen bunu inceleyin <a>yardım makalesi</a>',
        postSubmissionErrorMessage:
          "Sistem hatası nedeniyle dosyalarınızı yükleyemedik. Lütfen 'onayla' seçeneğini tekrar seçin.",
        tooltipAudio: 'Ses:',
        tooltipAudioOptions: '.ogg, .wav, .wma',
        tooltipDocuments: 'Belgeler:',
        tooltipDocumentsOptions:
          '.ps, .docx, .doc, .pptx, .ppt, .xlsx, .xls, .dcm, .pdf',
        tooltipImage: 'Görüntüler:',
        tooltipImageOptions:
          '.png, .apng, .jpg, .jpeg, .pjpeg, .svg, .gif, .tiff, .tif, .bmp, .psd, .avif',
        tooltipText: 'Metin:',
        tooltipTextOptions: '.txt, .csv, .html, .xml',
        tooltipVideo: 'Video:',
        tooltipVideoOptions: '.mp4, .mov, .mp1s, .asf',
        uploadErrors: {
          invalidFileSize: 'Dosya çok büyük',
          invalidFileType: 'Desteklenmeyen dosya türü: {{extension}}',
          systemError: 'Sistem hatası',
          tooManyFiles: 'Maksimum dosya sayısı {{maxFiles}}',
        },
        uploadFiles: 'Dosyaları yükle',
      },
      Loading: {
        loading:
          'Lütfen raporunuzu bir dosya yöneticisine sunarken bekleyin...',
        postSubmissionLoading:
          'Lütfen dosyanız(larınızın) gönderilmesini beklerken bekleyin...',
      },
      Location: {
        description: 'Nerede meydana geldi?',
        header: 'Nerede meydana geldi?',
        placeholder: 'Örneğin: iş yerinde',
      },
      MessageListBox: {
        messageCaseManager: 'Vaka yöneticisine mesaj gönder',
        report: 'Bildir {{displayReportId}} {{submissionType}}',
      },
      MessageSettings: {
        enableTranslationLabelDisabled: 'Çeviri devre dışı',
        enableTranslationLabelEnabled: 'Çeviri etkinleştirildi',
        enableTranslationsDescription:
          'Otomatik çevirileri etkinleştirin ve tüm rapor mesajlarını tercih ettiğiniz dilde okuyun. Çevrilen dil, cihazınızda seçilen dile dayanmaktadır.',
        enableTranslationsHeader:
          'Rapor mesajları için otomatik çevirileri etkinleştirin',
        enableTranslationsSubDescriptionv2:
          'Her sohbet içinde çevrilen dil ile orijinal dil arasında geçiş yapabilirsiniz.',
        updateTranslationFailed: 'Çeviri güncelleme başarısız oldu',
        updateTranslationSuccess: 'Çeviri ayarı başarıyla güncellendi',
      },
      Password: {
        changePasswordHeader: 'Parolayı Değiştir',
        createNewPassword: 'Lütfen yeni bir parola oluşturun',
        createPasswordHeader: 'Parolanız',
        currentPasswordPlaceholder: 'Mevcut parolanızı girin',
        description:
          'Geçerli bir parola en az 9 karakter uzunluğunda olmalı ve bir büyük harf ve bir sayı içermelidir',
        enterCurrentPassword: 'Lütfen mevcut parolanızı girin',
        forgottenPasswordInstructions:
          "Alfanumerik Vault ID'nizi (e-posta adresiniz değil) ve e-posta adresinizi şifrenizi sıfırlamak için girin.",
        newDescription:
          'Hesabınızı güvende tutmak için güçlü bir şifre oluşturun. Aşağıdaki yönergeleri görmek için yazmaya başlayın.',
        passwordPlaceholder: 'Parola oluşturun',
        passwordResetRequestedDescription:
          "Eğer Vault ID'niz sistemimizde mevcutsa, şifrenizi sıfırlama talimatlarının bulunduğu bir e-posta alacaksınız.",
        passwordResetRequestedHeader: 'Şifre sıfırlama bağlantısı talep edildi',
        reenterPlaceholder: 'Parolanızı tekrar girin',
        subtitle:
          'Bu raporu göndermek ve daha sonra erişim sağlamak için bir parola oluşturun',
        yourVaultId: 'Vault Kimlik Numaranız',
        yourVaultIdPlaceholder: "Vault ID'nizi girin (ör. {{exampleId}})",
      },
      Perpetrators: {
        description:
          'Belirli bir kişi veya birçok kişiyi mi bildiriyorsunuz? İsimlerini verebilir veya tanımlayabilir misiniz?',
        header: 'İlgili kişiler',
        placeholder:
          'Yazmaya başlayın ve birden çok isim veya tanım eklerken virgül kullanın',
      },
      PoweredByVault: '{{company}} tarafından sunulmaktadır',
      PrivacyStatement: 'Ürün Gizlilik Beyanı',
      PublicMessageList: {
        myMessages: 'Mesajlarım',
      },
      PublicMoreEvidence: {
        additionalEvidenceHeader: 'Mevcut rapora eklenen kanıt',
        backToReportId: "Rapor ID'ye geri dön: {{reportId}}",
        description:
          'Dosyaları kanıt olarak eklemek, durum yöneticinizin çözüm verimliliğini desteklemeye yardımcı olabilir. Anonim kalmak istiyorsanız lütfen dosya içeriğini (dosya metaverileri dahil) dikkate alın ve diğer kişilerin haklarına ve geçerli yasalara saygı gösterin. Daha fazla bilgi için lütfen bunu inceleyin. <a>yardım makalesi</a>',
        header: 'Rapora ekstra kanıtlar ekleyin',
        vaultTalkOpenCaseHeader: 'Raporunuza kanıt ekleyin',
      },
      PublicReport: {
        anonymous: 'Anonim',
        backToReports: 'Raporlara geri dön',
        skipped: 'Atlandı',
      },
      PublicReportCard: {
        addEvidence: 'Ek ekstra kanıt ekle',
        messageCaseManager: 'Vaka yöneticisine mesaj gönder',
        reportId: 'Rapor Kimliği:',
        submitted: 'Gönderildi',
        vaultTalkClosedCaseCTA: 'Kanıtları Görüntüle',
        vaultTalkOpenCaseCTA: 'Kanıt Ekle',
        viewAdditionalEvidence: 'Ekstra kanıtları görüntüleyin',
        viewReport: 'Raporu Görüntüle',
      },
      PublicReportsList: {
        reportingSystem: 'Bildirim Sistemi',
      },
      Question: {
        placeholder: 'Yazmaya başlayın...',
        question: 'Ayrıntıları sağlayın',
        questionText:
          'Lütfen endişenizi, güncellemenizi veya sorgunuzu bizimle paylaşın.',
      },
      Relationship: {
        header: 'Kuruluş ile aranızdaki ilişki',
        tellUsAbout: 'Lütfen kuruluş ile aranızdaki ilişkiden bahsedin.',
      },
      ResponsiveNavMenu: {
        messages: 'Benim mesajlarım',
        reports: 'Benim raporlarım',
      },
      Site: {
        description: 'Hangi tesiste çalışıyorsunuz?',
        header: 'Hangi tesiste çalışıyorsunuz?',
        noOptions: 'Tesis bulunamadı',
        other: 'Diğer',
        placeholder: 'Tesis arayın...',
      },
      SpamPuzzle: {
        dialog: 'Devam etmek için, lütfen bu bulmacayı çözün',
      },
      SubmissionTypes: {
        reportIssue: 'Bir kategori seçin',
        whatType: 'Raporunuzu en iyi tanımlayan kategoriyi seçin',
      },
      SubmitSuccess: {
        category: '<bold>Kategori:</bold> {{category}}',
        country: '<bold>Ülke:</bold> {{country}}',
        dateSubmitted: '<bold>Gönderim tarihi:</bold> {{date}}',
        recordYourVaultID: 'Bu bilgileri giriş için hatırla',
        successInformation: 'Daha fazla bilgi',
        successMessage:
          'Raporunuz gönderildi ve incelenmeye hazır. Dikkat gerektiren herhangi bir dosya, giriş yapıldığında işaretlenecektir. Rapor güncellemelerini görüntülemek ve durum yöneticinize mesaj göndermek için aşağıdan giriş yapın.',
        successSanitationMessage:
          "Kayıtlarınız için bir kopyasını saklayın ve Vault-ID'nizi güvende tutun - güncellemelere erişmek ve durum yöneticinize mesaj göndermek için buna ihtiyacınız olacak.",
        successSanitationTagline:
          'Raporunuz gönderildi ve güvenli bir şekilde saklandı.',
        successThankYou: 'Raporunuz için teşekkür ederim!',
        viewReport: 'Raporu görüntüle',
      },
      Time: {
        approximateDescription:
          'Olayın meydana geldiği yaklaşık saati hatırlıyor musunuz?',
        approximatePlaceholder: 'Örneğin: sabah, öğleden sonra',
        description: 'Olayın meydana geldiği saati hatırlıyor musunuz?',
        header: 'Hangi saatte meydana geldi?',
        invalidTime: 'Saat biçimi SS: DD olmalıdır',
      },
      UserSettingsDialog: {
        changePassword: 'Parolayı Değiştir',
        closeDialog: 'Konuşmayı Kapat',
        logout: 'Oturumu kapat',
        messageSettings: 'Mesaj Ayarları',
        userSettings: 'Kullanıcı Ayarları',
      },
      Witnesses: {
        description:
          'Başkalarına bahsettiniz mi veya olayı gören başkaları var mı?',
        header: 'Herhangi bir tanık var mı?',
        placeholder: 'Yazmaya başlayın...',
      },
    },
    reporting: {
      MessageSlideIn: {
        confirmButton: 'Mesaj gönder',
        title: 'Mesaj Durum Yöneticisi',
        translationHeader:
          'Otomatik çeviriler hakkında daha fazla bilgi edinin',
      },
      ReportCard: {
        addEvidence: 'Kanıt ekle',
        submissionModeVia: '{{submissionMode}} yoluyla',
        viewEvidence: 'Kanıtları görüntüleyin',
      },
      ReportList: {
        yourReports: 'Raporlarınız',
      },
      ReportingActivate: {
        buttonText: 'Devam et',
        description:
          'Eğer organizasyonunuz sizin adınıza bir hesap kaydetti ise, tam kurulumu tamamlamanız için talimatların bulunduğu bir e-posta göndereceğiz.',
        emailInput: 'E-posta',
        header: 'İş e-postanızı girin',
        successAccount:
          'Eğer organizasyonunuz sizin adınıza bir hesap kaydettiyse, kurulumu tamamlamanız için talimatların bulunduğu bir e-posta göndereceğiz.',
        successEmail:
          'Hemen görmezseniz, lütfen birkaç dakika bekleyin ve e-posta gelen kutunuzu yenileyin.',
        successHeading: 'Teşekkür ederim',
      },
      ReportingAddEvidence: {
        descriptionHeader: 'Raporunuza kanıt ekleyin',
        descriptionText:
          'Dosyaları kanıt olarak eklemek, durum yöneticinizin çözüm verimliliğini desteklemeye yardımcı olabilir. Anonim kalmak isterseniz, lütfen dosya içeriğini (dosya metaverileri dahil) dikkate alın ve diğer kişilerin haklarını ve geçerli kanunlara saygı gösterin. Daha fazla bilgi için lütfen bu <a>yardım makalesine</a> bakınız.',
        emptyMessage: 'Ek bir kanıt yüklenmedi',
      },
      ReportingChangePassword: {
        back: 'Geri',
        description:
          'Hesabınızı güvende tutmak için güçlü bir şifre oluşturun. Aşağıdaki yönergeleri görmek için yazmaya başlayın.',
        errorToast: 'Şifre oluşturulamıyor, geçersiz belirteç.',
        header: 'Şifreyi Değiştir',
        incorrectCurrentPassword:
          'Mevcut şifre yanlış. Lütfen kontrol edin ve tekrar deneyin.',
        invalidToken: 'Geçersiz simge',
        passwordUpdated: 'Şifre güncellendi',
        passwordUpdatedDescription:
          'Şifreniz başarıyla güncellendi. Verilerinizi güvende tutmak için bu adımı attığınız için teşekkür ederiz!',
        passwordUsedBefore: 'Parola yeniden kullanıma izin verilmiyor',
        passwordUsedBeforeDescription:
          'Güvenliğiniz için, son altı şifrenizden hiçbirini yeniden kullanamazsınız. Hesabınızı güvende tutmak için lütfen yeni ve benzersiz bir şifre seçin ve tekrar deneyin.',
        toastDescription:
          'Şifreniz başarıyla güncellendi. Verilerinizi güvende tutmak için bu adımı attığınız için teşekkürler!',
        toastMessage: 'Şifre güncellendi',
        updatePasswordCTA: 'Şifreyi güncelle',
      },
      ReportingConnect: {
        cancelButton: 'İptal',
        connectButton: 'Bağlan',
        disclaimer:
          'Slack hesabınızı Vault hesabınızla bağlamak, güvenli ve özel bir bağlantı sağlar.<br /><br />Bağlantı kurarak, her türlü yanlış davranışı bildirebilir veya doğrudan Slack içinde bir soru sorabilirsiniz. Bağlantı kurduktan sonra her zaman anonim olarak bildirimde bulunma seçeneğiniz olacaktır. Gizliliğiniz ve güvenliğiniz bizim öncelikli konularımızdır.',
        heading:
          'Vault Platform, {{organisationName}} Slack hesabınıza erişim izni istiyor.',
        listHeading: 'Vault ne yapabilecek?',
        permissionIdentity: {
          extraInfo:
            'Vault, Slack kullanıcınızın kimliğini görüntüleme yeteneğine sahip olacak.',
          heading: 'Bir kullanıcının kimlik bilgilerini görüntüleyin',
        },
        permissionNotifications: {
          extraInfo:
            'Vault, bir rapora veya soruya yapılan herhangi bir güncelleme hakkında size Slack hesabınıza bildirimler gönderebilecektir.',
          heading: 'Size bildirimler göndermek',
        },
        permissionOverview: {
          extraInfo:
            'Vault, ana sayfada tüm gönderilerin bir genel bakışını ortaya çıkaracak.',
          heading: 'Gönderilerin genel bakışı',
        },
        permissionSubmitReport: {
          extraInfo:
            "Bu, Vault'a bir rapor gönderme veya bir soru sorma izni verir, doğrudan organizasyonunuza, Slack üzerinden.",
          heading: 'Adınıza bir rapor sunun veya soru sorun',
        },
        successfulConnectionDescription:
          "Vault hesabınız ve Slack hesabınız şimdi bağlandı. Artık bu sekmeyi kapatabilir ve Slack'e dönebilirsiniz.",
        successfulConnectionHeading: 'Başarıyla bağlandı',
        unsuccessfulConnectionDescription:
          "Bir şeyler ters gitti. Lütfen bu sekme kapatılıp Slack'e geri dönerek tekrar deneyin.",
        unsuccessfulConnectionHeading: 'Bağlantı başarısız oldu',
      },
      ReportingForgotPassword: {
        description:
          'Hesabınızla ilişkili e-posta adresinizi girin ve size parolanızı sıfırlamanız için bir bağlantı göndereceğiz.',
        heading: 'Unutulan şifre',
        invalidTokenError: 'Parola oluşturulamıyor, geçersiz jeton.',
        passwordReuseError: 'Parola yeniden kullanıma izin verilmez',
        passwordReuseErrorDescription:
          'Güvenliğiniz için son altı şifrenizden hiçbirini tekrar kullanamazsınız. Hesabınızı güvende tutmak için lütfen yeni, benzersiz bir şifre seçin ve tekrar deneyin.',
        sendLink: 'Sıfırlama bağlantısını gönder',
        sendLinkFailure: 'Bir şeyler yanlış gitti',
        sendLinkFailureDescription:
          "<a>Reporter Hub</a>'a geri dönün ve tekrar deneyin. Sorun devam ederse, bize şu adresten ulaşın: <mailto>techsupport@vaultplatform.com</mailto>",
        sendLinkSuccess: 'Parola sıfırlama bağlantısı gönderildi',
        sendLinkSuccessDescription:
          '{{email}} adresine bir şifre yenileme bağlantısı gönderdik.',
        updatePasswordSuccess: 'Şifre güncellendi',
        updatePasswordSuccessDescription:
          'Şifreniz başarıyla güncellendi. Verilerinizi güvende tutmak için bu adımı attığınız için teşekkürler!',
      },
      ReportingLogin: {
        accountFrozen: 'Hesap donduruldu',
        accountLocked:
          'Giriş çok fazla sayıda yanlış denendi. Hesap en fazla 1 saat boyunca kilitlidir. Bu süre zarfında şifre sıfırlaması mümkün değildir.',
        accountLockedPermanently:
          'Hesabınız kilitlendi. Erişimi geri almak için şifreyi sıfırla özelliğini kullanın veya daha fazla yardım için sistem yöneticinize başvurun.',
        createAccountCTA: 'Bir hesap için kaydolun',
        currentPassword: 'Mevcut Şifre',
        emailLabel: 'E-postanız',
        forgotPassword: 'Şifrenizi mi unuttunuz?',
        loginButton: 'Giriş',
        newPasswordPlaceholder: 'Yeni şifre',
        passwordFailMessage:
          "Vault Uygulamasına Slack'te geri dönün ve tekrar deneyin. Sorun devam ederse, bize şu adresten ulaşın: techsupport@vaultplatform.com",
        passwordFailTitle: 'Bir şeyler yanlış gitti',
        passwordLabel: 'Şifreniz',
        passwordPlaceholder: 'Şifrenizi girin',
        passwordResetRequired: 'Şifre sıfırlama gereklidir',
        passwordSuccessfullySetMessage:
          "Vault uygulamasına Slack'te geri dönün ve kaldığınız yerden devam etmek için yeni şifrenizle kimlik doğrulaması yapın.",
        passwordSuccessfullySetTitle: 'Parola başarıyla ayarlandı',
        reenterPlaceholder: 'Şifreyi yeniden girin',
        title: 'Raporcu Hub',
        tooltip:
          'Eğer Vault uygulaması için henüz bir şifre belirlemediyseniz, başlamak için burayı takip edin. Şifrenizi unuttuysanız, aşağıdaki "Şifremi Unuttum" bağlantısını kullanın.',
        usernameLoginFailed: 'Giriş başarısız, kullanıcı adı veya şifre yanlış',
      },
      ReportingReset: {
        failureDescription:
          "Slack'taki Vault Uygulamasına geri dönün ve tekrar deneyin. Sorun devam ederse, bize <mailto>techsupport@vaultplatform.com</mailto> adresinden ulaşın.",
        failureHeading: 'Bir şeyler ters gitti',
        successDescription:
          "Slack'taki Vault Uygulamasına geri dönün ve kaldığınız yerden devam etmek için yeni şifrenizle kimlik doğrulaması yapın.",
        successHeading: 'Şifre başarıyla ayarlandı',
      },
      noReports: {
        description:
          'Gönderilen tüm raporlar burada gösterilecektir. Bir rapor gönderebileceğiniz yollar hakkında daha fazla bilgi edinin.',
        descriptionHelpArticle: 'bu yardım makalesi',
        errorDescription:
          'Raporlarınızı yüklemekte zorlanıyoruz. Lütfen sayfayı yenilemeyi deneyin.',
        errorDescriptionSecondary:
          'Eğer bu işe yaramazsa, lütfen bizimle iletişime geçin:',
        errorTitle: '⚠️ Hata, bir şeyler yanlış gitti',
        title: 'Henüz hiç raporunuz yok',
      },
      settings: {
        messageSettings: {
          autoTranslationDescription1:
            'Otomatik çevirileri etkinleştirin ve tüm rapor mesajlarınızı tercih ettiğiniz dilde okuyun. Çevrilen dil, cihazınızda seçilen dile dayalıdır.',
          autoTranslationDescription2:
            'Her sohbet içinde çevrilmiş dil ve orijinal dil arasında geçiş yapabilirsiniz.',
          autoTranslationTitle:
            'Rapor mesajları için otomatik çevirileri etkinleştirin',
          header: 'Mesaj Ayarları',
          subHeader: 'Mesajların nasıl görüntüleneceğini yapılandırın',
        },
        notificationSettings: {
          emailDescription:
            'Raporlarınızdaki önemli güncellemeler için e-posta bildirimleri alın',
          emailTitle: 'E-posta Bildirimleri',
          header: 'Bildirim Ayarları',
          subHeader: 'Bildirimleri nasıl alacağınızı yapılandırın',
        },
        title: 'Ayarlar',
        updatedSettingsFailure: 'Ayarlarınızı güncelleme başarısız oldu',
        updatedSettingsSuccess: 'Ayarlarınız başarıyla güncellendi',
      },
    },
    validators: {
      passwordLength: 'Parola en az 9 karakter uzunluğunda olmalı',
      passwordLowercase: 'Parola en az 1 küçük harf içermeli',
      passwordMissMatch: 'Parola ve onay alanları birbirleriyle eşleşmelidir.',
      passwordNumeric: 'Parola en az 1 sayı içermeli',
      passwordUppercase: 'Parola en az 1 büyük harf içermeli',
    },
    validatorsNew: {
      passwordLength: '10 ve 30 karakter arası',
      passwordLowercase: 'En az bir küçük harf',
      passwordMissMatch: 'Şifreler eşleşmiyor',
      passwordNumeric: 'En az bir numara',
      passwordSpecialCharacter: 'En az bir özel karakter',
      passwordUppercase: 'En az bir büyük harf',
    },
  },
};

export default translations;
